import {
  Link,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import PaginationLayout from "../components/PaginationLayout";
import Modal from "react-bootstrap/Modal";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import Button from "react-bootstrap/Button";

import moment from "moment";
import Swal from "sweetalert2";
import { getUserProfileImage } from "../utils/constant_value";

function ReportedReels() {
  const location = useLocation();
  const match = useMatch("/reported-reels/:page");
  const navigate = useNavigate();
  const param = useParams();

  const newParam = new URLSearchParams(location.search);

  const {
    authState,
    staticDataState,
    currentUsd,
    handleError,
    // loading,
    staticDataDispatch,
    scrollToTop,
    handlePagination, handleFilter
  } = useContext(GlobalContext);
  const nfts = staticDataState.nfts;

  henceforthApi.setToken(authState.access_token);

  //Modals
  const [Coins, setCoins] = useState(false);
  const handleCloseCoins = () => setCoins(false);
  const [loading, setLoading] = useState(false);

  const [like, setLike] = useState(false);
  const [comment, setComment] = useState(false);
  const [manageMedias, setManageMedias] = useState({
    type: "",
    _id: "",
    admin_verified: false,
    language: "ENGLISH",
    account_status: "",
  });

  // Video one stop if another play
  var videoPlaying = null;
  const onPlay = function () {
    if (videoPlaying && videoPlaying != this) {
      videoPlaying.pause();
    }
    videoPlaying = this;
  };
  const videos = document.getElementsByClassName("video-bg");
  for (let i = 0; i < videos.length; i++) {
    videos[i].addEventListener("play", onPlay);
  }

  //Fetch
  const [reelsData, setReelsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  let limit = 9;
  const fetchReels = async () => {
    try {
      setLoading(true)
      const ReelRes = await henceforthApi.Reported.reels(
        "2",
        Number(param.page) - 1,
        limit,
        query.toString()
      );
      setReelsData(ReelRes.reels);
      setTotalCount(ReelRes.count);
      setLoading(false)
    } catch (error) {
      handleError(error)
    }
  };

  var query = new URLSearchParams(location.search);
  const filters = [
    { name: "Activated", value: "Active" },
    { name: "Deactivated", value: "Deactive" }
  ];

  //Remove
  const [showRemove, setShowRemove] = useState(false);
  const handleConfirm = (id) => {
    setShowRemove(id);
  }
  const handleRemove = async (id) => {
    try {
      await henceforthApi.Reels.delete(id);
      setShowRemove(false);
      fetchReels();
    } catch (Error) {
    }
    setShowRemove(false)
  };
  //Coins
  const [getCoins, setGetCoins] = useState([]);
  const [totalCoins, setGetTotalCoins] = useState({});
  const HandleCoins = async (Coin) => {
    setCoins(true);
    try {
      const CoinsResponse = await henceforthApi.Posts.coins(Coin);
      setGetCoins(CoinsResponse);
      setGetTotalCoins(CoinsResponse);
    } catch (error) {
    }
  };
  //Like
  const [getLike, setGetLike] = useState([]);
  const HandleLike = async (like) => {
    setLike(true);
    try {
      const likeResponse = await henceforthApi.Posts.like(like);
      setGetLike(likeResponse);
    } catch (error) {
    }
  };
  //Comment
  const [getComment, setGetComment] = useState([]);
  const HandleComment = async (LC) => {
    setComment(true);
    try {
      const CommentResponse = await henceforthApi.Posts.Comment(LC);
      setGetComment(CommentResponse);
    } catch (error) {
    }
  };

  useEffect(() => {
    scrollToTop();
    fetchReels();
  }, [param.page, newParam.get("search"), manageMedias, query.toString()]);

  return (
    <>
      <div class="row animated fadeInRight">
        <div class="col-md-12">
          <div className="ibox">
            <div className="ibox-title d-flex align-items-center justify-content-between">
              <div className="dropdown theme me-3">
                <button
                  className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
                  id="sortDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {filters.filter((res) => res.value == query.get("filter"))
                    .length
                    ? filters.filter(
                      (res) => res.value === query.get("filter")
                    )[0].name
                    : "All"}
                  {/* <i
                className="fas fa-chevron-down bi-chevron-down ms-2 "
                style={{ fontSize: "12px" }}
              ></i> */}
                </button>
                <ul
                  className="dropdown-menu share-icons"
                  aria-labelledby="sortDropdown"
                >
                  {query.has("filter") && (
                    <li className="cursor-pointer">
                      <a
                        className="dropdown-item"
                        onClick={() => handleFilter("filter", "")}
                      >
                        All
                      </a>
                    </li>
                  )}
                  {filters.map((res) => {
                    return (
                      <li key={res.value} className="cursor-pointer">
                        <a
                          className="dropdown-item"
                          onClick={() => handleFilter("filter", res.value)}
                        >
                          {res.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="ibox-title d-flex align-items-center justify-content-between"></div>
            <div className="ibox-content">
              <div className="row">
                {!loading && !reelsData?.length ? <div className="text-center"> <b>No Reels Found </b> </div> : reelsData?.map((item, index) => (
                  <div class="col-md-4 mb-4">
                    <div class="card mb-4 box-shadow border-0 shadow h-100">
                      <Link to="">
                        {Array.isArray(item?.post_medias) &&
                          item?.post_medias.map((res, index) => (
                            <div className="explore-img" key={index}>
                              <video
                                id="videos"
                                class="video-bg"
                                src={`https://shadowzapp.sgp1.digitaloceanspaces.com/shadowzapp/video/${res.media_url}`}
                                autostart
                                controls
                                muted
                                controlsList="nodownload"

                              />
                            </div>
                          ))}
                      </Link>
                      <div class="card-body">

                        <div className="username-box my-1 d-flex justify-content-between align-items-center">
                          <div className="d-flex gap-1 ProfileImagePRS-box">
                            <img className="ProfileImagePRS" src={getUserProfileImage(item?.profile_pic)} alt="" />
                            <Link
                              to={`/user/${item?.user_id}/1/1?type=reels`}
                              className="Details_of_User"
                            >
                              <p className="fw-bolder m-0" style={{ fontSize: "14px" }}>
                                {item?.name}
                              </p>
                            </Link >
                          </div>
                          <div>
                            <label className="PublicPrivate">
                              <i
                                class={item?.is_private == false ?
                                  `fas fa-globe-africa` : `fas fa-lock`}
                                style={{ marginRight: "3px" }}
                              ></i>
                              {item?.is_private == false
                                ? "Public"
                                : "Private"}
                            </label>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6">
                            <div className="desc-box" style={{ minHeight: "45px" }}>
                              <p className="m-0" style={{ fontSize: "14px" }}>
                                <b>Description:</b> <span>{item?.discription}</span>
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-end">
                              <label className={item.status == "Active" ? "custom-status" : "custom-status-deactivate"}>
                                {item.status}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="both-added my-3">
                          <div className="">
                            <div className="fw-bolder">
                              <h6
                                onClick={() => HandleCoins(item.post_id)}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                Coin:
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    marginLeft: "3px",
                                  }}
                                >
                                  <i
                                    style={{
                                      marginRight: "2px",
                                      fontSize: "17px",
                                    }}
                                    class="fas fa-usd-circle"
                                  ></i>
                                  {item?.coins_count}
                                </span>
                              </h6>
                              <h6
                                // className="SongsDiv"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                Song Name:
                                <span
                                  className="Songs_Reels"
                                  style={{
                                    fontWeight: "bold",
                                    marginLeft: "3px",
                                    fontSize: "12px !important",
                                    color: "e5e5e5",
                                  }}
                                >
                                  {item?.song_name}
                                </span>
                              </h6>
                            </div>
                          </div>
                          <div className="brown-text text-wrap">
                            <div
                              style={{ cursor: "pointer" }}
                              className="fw-bolder text-end"
                            >
                              <h6
                                style={{ fontSize: "14px" }}
                                onClick={() => HandleComment(item.post_id)}
                              >
                                {" "}
                                Comments:
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "14px ",
                                    marginLeft: "3px",
                                  }}
                                >
                                  {item.comments_count}
                                </span>
                              </h6>
                              <h6
                                style={{ fontSize: "14px" }}
                                onClick={() => HandleLike(item.post_id)}

                              >
                                Likes:
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    marginLeft: "3px",
                                  }}
                                >
                                  {item.likes_count}
                                </span>
                              </h6>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="">
                          <h6
                            className="text-ellipse"
                            style={{ fontSize: "14px" }}
                          >
                            {" "}
                            Report Reason :{" "}
                            <span
                              title={item?.reportedReason}
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                              {item.report_reason}
                            </span>
                          </h6>
                          <h6 className="" style={{ fontSize: "14px" }}>
                            Reported By :
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              {item?.reported_by?.length ? item?.reported_by?.slice(0, 3)?.map((res, index) => { return `${res?.full_name + `${index < item?.reported_by?.length - 1 ? "," : ""}`}` }) : ""}
                            </span>
                            <span className="ms-5">{item?.reported_by?.length > 3 ? <b className="" style={{
                              cursor
                                : "pointer"
                            }}>....view more</b> : ""}</span>
                          </h6>
                        </div>
                        <hr />
                        <div className="row align-items-center">
                          <div className="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="btn-group">
                                <div className="bown-num ">
                                  <p className="m-0">
                                    {" "}
                                    <small style={{ whiteSpace: "nowrap" }}>
                                      {moment(Number(item.created_at)).format(
                                        "DD MMM YYYY, h:mm a"
                                      )}
                                    </small>{" "}
                                  </p>
                                </div>{" "}
                                <div className="bown-num"></div>
                              </div>

                            </div>

                          </div>

                          {/* {item.is_removed == true ? (
                            " "
                          ) : ( */}
                          <div className="col-md-6">
                            {/* <button
                                  onClick={() => handleActivate(item?.post_id, item?.status)}
                                  style={{ float: "right" }}
                                  className="btn btn-danger"
                                >
                                  {item?.status == "Active" ? "Active" : "Deactive"}
                                </button> */}
                            <Link to={`/media/${item._id}/like`}>
                              <div className="text-end">
                                <button
                                  onClick={() => handleConfirm(item._id)}
                                  style={{ float: "right" }}
                                  className="btn mt-2 btn-outline-dark"
                                >
                                  Details
                                </button>
                              </div>
                            </Link>
                          </div>
                          {/* )} */}
                          {/* Remove modal */}
                          <Modal
                            show={showRemove}
                            onHide={() => setShowRemove(false)}
                            backdrop="static"
                            keyboard={false}
                            centered
                            className="confirm-box-modal"
                          >
                            <Modal.Header>
                              <Modal.Title>
                                Remove
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <div className="my-3 text-center">
                                Do you want to Remove?
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button onClick={() => setShowRemove(false)} className="px-6 confirm-btn">
                                No
                              </Button>
                              <Button onClick={() => handleRemove(showRemove)} className="px-6 confirm-btn">
                                Yes
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div>
                <Modal
                  show={Coins}
                  onHide={handleCloseCoins}
                  centered
                  scrollable
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <Link
                        to=""
                        style={{
                          textDecoration: "none",
                          color: "#000000",
                          cursor: "auto",
                        }}
                      >
                        Coins
                      </Link>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
                      {getCoins?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Coins</div> : getCoins?.data?.map((item, index) => (
                        <div className="col-sm-12 ">
                          <div
                            className="image-name-box d-flex gap-2 align-items-right justify-content-between px-3"
                            key={index}
                          >
                            <div className="d-flex gap-2 align-items-center">
                              <div className="image-box">
                                <img
                                  src={
                                    item?.users?.profile_pic
                                      ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.users?.profile_pic}`
                                      : profile_placeholder
                                  }
                                  alt="ProfileImage"
                                  class="modal-profile"
                                />
                              </div>
                              <div className="name-box">
                                <Link
                                  to={`/user/${item.users?._id}/1/1?type=posts`}
                                  className="Details_of_User"
                                >
                                  <p className="mb-0 profile-name">
                                    {item?.users?.full_name}
                                  </p>
                                </Link>
                                <div>
                                  <p
                                    className="m-0"
                                    style={{
                                      fontSize: "10px",
                                    }}
                                  >
                                    {moment(
                                      Number(item?.users?.created_at)
                                    ).format("DD MMM YYYY, h:mm a")}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="image-name-box">
                              <p>
                                <i
                                  style={{ marginRight: "2px" }}
                                  class="fas fa-usd-circle"
                                ></i>
                                {item?.coins}
                              </p>
                            </div>
                          </div>
                          <hr />
                        </div>
                      ))}
                      {totalCoins?.coins_count == 0 ? " " :
                        <>
                          <div className="col-sm-8 d-flex gap-2 align-items-center">
                            <h6 style={{ fontWeight: "bold" }} className="ps-3">
                              Total Received :
                            </h6>
                          </div>
                          <div className="col-sm-4">
                            <dt className="text-end pe-3">
                              <i
                                style={{ marginRight: "2px" }}
                                class="fas fa-usd-circle"
                              ></i>
                              {totalCoins?.coins_count}
                            </dt>
                          </div>
                        </>
                      }
                    </div>
                  </Modal.Body>
                </Modal>
                {/* ))} */}
                <Modal
                  show={like}
                  onHide={() => setLike(false)}
                  centered
                  scrollable
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      Likes
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {getLike?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Likes</div> : getLike?.data?.map((item, index) => (
                      <>
                        <div
                          className="modal-wrapper d-flex align-items-center  mx-2"
                          key={index}
                        >
                          <img
                            src={
                              item?.profile_pic
                                ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.profile_pic}`
                                : profile_placeholder
                            }
                            alt="ProfileImage"
                            class="modal-profile me-2"
                          />
                          <Link
                            to={`/user/${item?.user_id}/1/1?type=posts`}
                            className="Details_of_User"
                          >
                            <p className="mb-0 profile-name">{item.name}</p>
                          </Link>
                        </div>
                        < hr />
                      </>
                    ))}
                  </Modal.Body>
                </Modal>
                {/* Comment */}
                <Modal
                  show={comment}
                  onHide={() => setComment(false)}
                  centered
                  scrollable
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      Comments
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {getComment?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Comments</div> : getComment?.data?.map((item, index) => (
                      <>
                        <div
                          className="image-name-box d-flex gap-2 align-items-start w-100"
                          key={index}
                        >
                          <div className="image-box">
                            <img
                              src={
                                item?.profile_pic
                                  ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.profile_pic}`
                                  : profile_placeholder
                              }
                              alt="ProfileImage"
                              class="modal-profile align-items-start"
                            />
                          </div>

                          <div className="name-box w-100">
                            <div className="d-flex align-items-center justify-content-between ">
                              <div>
                                <Link
                                  to={`/user/${item?.user_id}/1/1?type=posts`}
                                  className="Details_of_User"
                                >
                                  <p className="mb-0 profile-name">
                                    {item.name}
                                  </p>
                                </Link>
                              </div>
                              <div className="">
                                <p
                                  className="m-0"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {moment(Number(item.created_at)).format(
                                    "DD MMM YYYY, h:mm a"
                                  )}
                                </p>
                              </div>
                            </div>
                            <p
                              className="m-0"
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {item.comments}
                            </p>
                          </div>
                        </div>
                        <hr />
                      </>
                    ))}
                  </Modal.Body>
                </Modal>
              </div>

              <PaginationLayout
                count={totalCount}
                data={reelsData}
                page={Number(param.page)}
                limit={Number(limit)}
                loading={loading}
                onPageChange={(val) => handlePagination(val)}
              />
            </div>
          </div>
        </div >
      </div >
    </>
  );
}

export default ReportedReels;
